/**
 * Separated out the shared logging functionality from the CheckoutProvider so we don't re-render
 * components that are solely using the logger.
 */

import React, { createContext } from 'react'

import { AppLogger } from '@/utils/app-logger'

interface LoggerProviderProps {
    logger: AppLogger
}

interface LoggerProviderValue {
    actions: AppLogger
}

const defaultContext: LoggerProviderValue = {
    actions: {
        logError: () => null,
        logInfo: () => null,
    },
}

const loggerContext = createContext(defaultContext)
const { Provider } = loggerContext

export const LoggerProvider: React.FC<LoggerProviderProps> = ({ children, logger }) => {
    return (
        <Provider
            value={{
                actions: logger,
            }}
        >
            {children}
        </Provider>
    )
}

export default loggerContext
